/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { ApiResult } from './ApiResult';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
class WarningMessage {
    code;
    agent;
    text;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(code, agent, text) {
        this.code = code;
        this.agent = agent;
        this.text = text;
        Object.freeze(this);
    }
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
const isAxiosLike = (obj) => !(obj instanceof Response) &&
    typeof obj === 'object' &&
    obj != null &&
    Object.hasOwn(obj, 'headers');
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class WarningHeader {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    messages;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(warnings) {
        this.messages = Object.freeze(warnings);
        Object.freeze(this);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static fromWarningStr(warningStr) {
        if (warningStr instanceof WarningHeader) {
            return warningStr;
        }
        else if (warningStr == null || warningStr === '') {
            return new WarningHeader([]);
        }
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        const consume = (part) => {
            const arr = part.split(' ');
            const code = parseFloat(arr[0]);
            const agent = arr[1];
            const text = arr.slice(2).join(' ').replace(/\\(.)/g, '$1').slice(1, -1);
            return new WarningMessage(code, agent, text);
        };
        const warnings = [];
        for (let i = 0, seenQuote = false, startIndex = 0, len = warningStr.length; i < len; ++i) {
            const cur = warningStr.charAt(i);
            if (cur === '"') {
                if (seenQuote) {
                    warnings.push(consume(warningStr.slice(startIndex, i + 1)));
                    // Next char is a comma and then a space
                    startIndex = i + 3;
                    seenQuote = false;
                }
                else {
                    seenQuote = true;
                }
            }
            else if (cur === '\\') {
                // Skip next char
                i++;
            }
        }
        return new WarningHeader(warnings);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static fromHeaders(headers) {
        return WarningHeader.fromWarningStr(headers.get('Warning'));
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static fromResponse(response) {
        if (response instanceof Response) {
            return WarningHeader.fromHeaders(response.headers);
        }
        else {
            const warningStr = response?.headers?.warning;
            return WarningHeader.fromWarningStr(warningStr ?? '');
        }
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    merge(obj) {
        let other;
        if (obj instanceof WarningHeader) {
            other = obj;
        }
        else if (obj instanceof ApiResult) {
            other = obj.warnings;
        }
        else if (obj instanceof Response) {
            other = WarningHeader.fromResponse(obj);
        }
        else if (isAxiosLike(obj)) {
            other = WarningHeader.fromResponse(obj);
        }
        else if (obj) {
            other = WarningHeader.fromWarningStr(obj);
        }
        else {
            return this;
        }
        return new WarningHeader(this.messages.concat(other.messages));
    }
}
